import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BusyService } from '@unleashed/services/common';
import { phoneNumberValidator, selectOptionValidator, zipCodeFormatValidator } from '@unleashed/common/validators';
import { User } from '@unleashed/models/account';
import { AuthorizationService } from '@unleashed/services/account';
import { StatesApiService } from '@unleashed/api/address';
import { State } from '@unleashed/models/address';

@Component({
  selector: 'ua-account-info-form',
  templateUrl: './account-info-form.component.html',
  styleUrls: ['./account-info-form.component.scss']
})
export class AccountInfoFormComponent implements OnInit {

  accountForm: FormGroup;
  formDirty = false;
  user?: User;
  states: State[] = [];
  @Output() saveClicked = new EventEmitter<void>();
  @Output() cancelClicked = new EventEmitter<void>();

  constructor(
    private authService: AuthorizationService,
    private stateService: StatesApiService,
    private busyService: BusyService
  ) {
    this.accountForm = new FormGroup({});
  }

  ngOnInit(): void {
    this.busyService.set('account-info', true);

    this.authService.getUser()
      .subscribe(user => {
        this.accountForm = new FormGroup({
          firstName: new FormControl(user.firstName ?? '', [Validators.required]),
          lastName: new FormControl(user.lastName ?? '', [Validators.required]),
          phoneNumber: new FormControl(user.phoneNumber ?? '', [Validators.required, phoneNumberValidator()]),
          address: new FormControl(user.address?.streetAddress ?? '', [Validators.required]),
          city: new FormControl(user.address?.city ?? '', [Validators.required]),
          state: new FormControl(user.address?.state ?? -1, [Validators.required, selectOptionValidator([-1])]),
          zip: new FormControl(user.address?.zipCode ?? '', [Validators.required, zipCodeFormatValidator()])
        });
        this.user = user;
      });

    this.stateService.get()
      .subscribe(states => {
        this.states = states;
        this.busyService.set('account-info', false);
      });
  }

  save(): void {
    this.formDirty = true;
    if (!this.accountForm.valid) {
      return;
    }

    this.authService
      .update(
        {
          ...this.user,
          firstName: this.accountForm.value.firstName,
          lastName: this.accountForm.value.lastName,
          phoneNumber: this.accountForm.value.phoneNumber,
          address: {
            id: this.user?.address?.id,
            hashCode: this.user?.address?.hashCode,
            format: 'us',
            streetAddress: this.accountForm.value.address,
            city: this.accountForm.value.city,
            state: this.accountForm.value.state,
            country: 'US',
            zipCode: this.accountForm.value.zip,
          }
        }
      )
      .subscribe(() => {
        this.saveClicked.emit();
      });
  }

  cancel(): void {
    this.cancelClicked.emit();
  }

}
